// extracted by mini-css-extract-plugin
export default {"listWrapper":"List_listWrapper__C0yUk","listHeader":"List_listHeader__SGbR3","cell":"List_cell__RnbOO","listItem":"List_listItem__Zo9IY","modifyIcon":"List_modifyIcon__PlIAD"};